import React, { useState, useEffect, useRef } from 'react';
import { Layer, Circle } from 'react-konva';

const MarkComponent = ({ markDetails, saveMark, dxfScale, gridScaleX, gridScaleY, stageScale = 1 }) => {
    const { x, y, step, show, rings } = markDetails;
    const [currentX, setCurrentX] = useState(x);
    const [currentY, setCurrentY] = useState(y);
    const circleRef = useRef(null);
    const safeStageScale = Math.max(0.1, Number(stageScale) || 1);

    useEffect(() => {
        setCurrentX(x);
        setCurrentY(y);
    }, [x, y]);

    const handleDragMove = (e) => {
        // console.log('Dragging to:', e.target.x(), e.target.y());
        const newX = e.target.x();
        const newY = e.target.y();
        setCurrentX(newX);
        setCurrentY(newY);
    };

    const handleDragMoveEnd = (e) => {
        const newX = e.target.x();
        const newY = e.target.y();

        saveMark({ x: newX, y: newY });
    };

    return (
        <Layer>
            {show && (
                <>
                    {Array.from({ length: rings }).map((_, index) => {
                        const circleRadius = Math.max(0.5, step * dxfScale * gridScaleX) * (index + 1);
                        return (
                            <Circle
                                key={index}
                                x={currentX}
                                y={currentY}
                                radius={circleRadius}
                                stroke="gray"
                                fill="transparent"
                                strokeWidth={Math.max(0.03, 0.8 / safeStageScale)}
                                listening={false}
                            />
                        );
                    })}

                    <Circle
                        ref={circleRef}
                        x={currentX}
                        y={currentY}
                        radius={Math.max(0.3, 5 / safeStageScale)}
                        stroke="gray"
                        fill="gray"
                        strokeWidth={Math.max(0.06, 1.2 / safeStageScale)}
                        draggable
                        dragDistance={0}
                        onDragMove={handleDragMove}
                        onDragEnd={handleDragMoveEnd}
                    />
                </>
            )}
        </Layer>
    );
};

export default MarkComponent;
